import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "title", "items", "selectionMode", "layoutType", "backgroundColor", "outline", "onExpandedChange", "expandedDefault", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { RichText } from '@sbercloud/uikit-product-site-rich-text';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { AccordionPrimary } from '@snack-uikit/accordion';
import { Typography } from '@snack-uikit/typography';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { getBlockDescriptionSize, getBlockTitleProps } from './utils';

// Had to copy props to save proper typings
import { jsx as _jsx } from "react/jsx-runtime";
export function SectionAccordion(_ref) {
  var id = _ref.id,
    title = _ref.title,
    items = _ref.items,
    _ref$selectionMode = _ref.selectionMode,
    selectionMode = _ref$selectionMode === void 0 ? 'multiple' : _ref$selectionMode,
    layoutType = _ref.layoutType,
    backgroundColor = _ref.backgroundColor,
    outline = _ref.outline,
    onExpandedChange = _ref.onExpandedChange,
    expandedDefault = _ref.expandedDefault,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    title: title,
    layoutType: layoutType,
    backgroundColor: backgroundColor
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsx(AccordionPrimary, {
      selectionMode: selectionMode,
      expandedDefault: expandedDefault,
      onExpandedChange: onExpandedChange,
      className: styles.accordion,
      children: items.map(function (_ref2, index) {
        var title = _ref2.title,
          description = _ref2.description,
          onClick = _ref2.onClick;
        return /*#__PURE__*/_jsx(AccordionPrimary.CollapseBlock, {
          id: index.toString(),
          header: /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({
            family: "sans"
          }, getBlockTitleProps(layoutType)), {}, {
            className: styles.title,
            children: /*#__PURE__*/_jsx(RichText, {
              richText: title
            })
          })),
          className: className,
          removeContentFromDOM: false,
          outline: outline,
          onClick: onClick,
          children: /*#__PURE__*/_jsx(Typography, {
            family: "sans",
            purpose: "body",
            tag: "div",
            size: getBlockDescriptionSize(layoutType),
            className: styles.description,
            children: /*#__PURE__*/_jsx(RichText, {
              richText: description
            })
          })
        }, index);
      })
    })
  }));
}